import { useEffect, useRef } from 'react'

// soundcloud widget configuration
// https://developers.soundcloud.com/docs/api/html5-widget
const widgetOptions = {
  auto_play: false,
  buying: false,
  // color: 'FF5500',
  download: false,
  following: false,
  hide_related: true,
  // inverse: !1, // don't know what this does
  liking: false,
  // secret_token: '',
  sharing: false,
  show_artwork: true,
  show_comments: false,
  show_playcount: false,
  show_reposts: false,
  show_teaser: true,
  show_user: true,
  // single_active: true,
  // start_track: 0,
  // tracking: '',
  visual: true,
  locale: 'en',
}

interface Props {
  trackId: number,
  onPlayProgress?: SoundCloud.AudioEventCallback
  registerSeekTo?: (seekTo: SoundCloud.SeekToFn) => void
}

export default function SoundCloudWidget (props: Props) {
  const { trackId, onPlayProgress, registerSeekTo } = props
  const iframeRef = useRef(null)
  const widgetRef = useRef<SoundCloud.Widget | null>(null)

  useEffect(() => {
    if (!widgetRef.current && iframeRef.current) {
      const widget = widgetRef.current = SC.Widget(iframeRef.current)
      if (!!onPlayProgress) {
        widget.bind(SC.Widget.Events.PLAY_PROGRESS, details => onPlayProgress(details))
      }
      if (registerSeekTo) {
        registerSeekTo((ms: number) => widget.seekTo(ms))
      }
    }
  })

  const trackUrl = `https://api.soundcloud.com/tracks/${trackId}`

  const srcUrl = `https://w.soundcloud.com/player/?${Object.entries({
    url: trackUrl,
    ...widgetOptions,
  }).map(([key, value]) => {
    return `${key}=${encodeURIComponent(value.toString())}`
  }).join('&')}`

  return (
    <>
      <iframe
        ref={iframeRef}
        className='widget'
        title='SoundCloudWidget'
        src={srcUrl.toString()}
      ></iframe>
    </>
  )
}
